import { Injectable } from '@angular/core';
import { EmailRecord } from '@app/_models/email-record';
import { AlertService } from '@app/_services';
import { MsalService } from '@azure/msal-angular';
import Swal from 'sweetalert2';
import { RestService } from './rest.service';
import { Email } from '@app/_models/email';
import { FunctionsService } from './functions.service';
import { InternalTrade } from '@app/_models/internal-trade';
import { DatePipe } from '@angular/common';
import { Case } from '@app/_models/case';
import { DatumNote } from '@app/_models/datumNote';
import { JobHistory } from '@app/_models/job-history';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { ErrorService } from './error.service';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(private alertService: AlertService,
    private errorService: ErrorService,
    private msalService: MsalService,
    public functionsService: FunctionsService,
    private datePipe: DatePipe,
    private router: Router,
    public restService: RestService) { }

  async retractEmailRecord(emailRecordId: number, tradeName: string, tradeId: number, contractorOrInternalTrade: string, instructionType: string) {
    this.alertService.clear();
    let title =
      'An email will be sent to <b><u>' +
      tradeName +
      '</b></u> to disregard this ' + instructionType + '\r\n<b><u><p style="color:red">This cannot be reversed if you proceed!!!</p></b></u>Are you sure you want to Retract this?';
    await Swal.fire({
      title: title,
      text: 'Please provide the reason for cancellation',
      input: 'text',
      inputPlaceholder: 'Please enter the reason here',
      showClass: {
        popup: 'animate__animated animate__fadeInDown',
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp',
      },
      icon: 'warning',
      showDenyButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
      confirmButtonColor: '#007bff',
      denyButtonColor: '#dc3545',
      focusDeny: true,
      width: 450,
      padding: '1em',
      heightAuto: false,
      inputValidator: (value) => {
        if (!value) {
          return 'You need to write something!';
        } else if (value.length > 250) {
          return 'Reason too Long!. Should be less than 250 characters';
        } else {
          return '';
        }
      },
    }).then(async (result) => {
      let retractReason = result.value;
      if (result.isConfirmed) {
        let emailRecord = new EmailRecord();
        emailRecord.id = emailRecordId;
        emailRecord.retracted = true;
        emailRecord.retractedBy =
          this.msalService.instance.getActiveAccount()!.name!;
        emailRecord.retractedOn = new Date();
        emailRecord.statusId = (instructionType == "quote request") ? 28 : 2;

        this.restService
          //Works up to this point
          .updateEmailRecord(emailRecordId, 2, emailRecord)
          .pipe(first())
          .subscribe({
            next: () => {
              try {
                this.restService
                  .getEmailRecord(emailRecordId)
                  .subscribe((emailRecord: EmailRecord) => {
                    var email: Email;
                    let riskAddress = '';

                    this.restService
                      .getCase(emailRecord.refNo)
                      .subscribe((caseDetails: Case) => {
                        riskAddress = (
                          this.functionsService.blankIfNull(
                            caseDetails.situationStreet
                          ) +
                          ' ' +
                          this.functionsService.blankIfNull(
                            caseDetails.situationSuburb
                          ) +
                          ' ' +
                          this.functionsService.blankIfNull(caseDetails.state) +
                          ' ' +
                          this.functionsService.blankIfNull(
                            caseDetails.postCode
                          )
                        )?.trim();
                        let tradeNamesGreeting = '';

                        if (contractorOrInternalTrade == 'Internal Trade' && tradeId) {
                          let additionalInternalTradeIDs: number[];
                          if (emailRecord.additionalInternalTrades != null) {
                            additionalInternalTradeIDs =
                              emailRecord.additionalInternalTrades
                                .split(',')
                                .map(Number);

                            this.restService
                              .getInternalTrades()
                              .subscribe(
                                (internalTradesArray: Array<InternalTrade>) => {
                                  if (internalTradesArray.length != 0) {
                                    additionalInternalTradeIDs.forEach(
                                      (item: number) => {
                                        tradeNamesGreeting =
                                          tradeNamesGreeting +
                                          ', ' +
                                          internalTradesArray.find(
                                            (trade) => item == trade.employeeId
                                          )?.displayName;
                                      }
                                    );
                                  }
                                }
                              );
                          }

                        }
                        tradeNamesGreeting =
                          'Hello ' +
                          tradeName +
                          tradeNamesGreeting;
                        let body =
                          tradeNamesGreeting +

                          ',<br/>Please cancel the previous email ' + instructionType + ' sent on ' +
                          this.datePipe.transform(
                            emailRecord.dateSent,
                            'dd/MM/yyyy'
                          ) +
                          ' with the subject <u>' +
                          emailRecord.subject +
                          '</u>, for the address ' +
                          riskAddress;
                        email = {
                          from: emailRecord.fromEmail,
                          to: emailRecord.toEmail,
                          cc: emailRecord.ccEmails,
                          bcc: 'test@mk3.com.au',
                          subject: 'Please Cancel - ' + emailRecord.subject,
                          body: body,
                          attachmentName: null,
                          attachmentContent: null,
                          extraAttachmentName: null,
                          extraAttachmentContent: null,
                        };

                        //Intermittant failing
                        this.restService.sendEmail(email, 'Email Type:' + contractorOrInternalTrade + ' Retract ' + instructionType + ', User Name:' + this.msalService.instance.getActiveAccount()!.name!
                          + ', RefNo:' + emailRecord.refNo.toString() + ', ' + contractorOrInternalTrade + ':' + tradeName + ', ' + contractorOrInternalTrade + 'Id:' + tradeId.toString()
                          + ', EmailRecordId:' + emailRecordId.toString()).subscribe(
                            (response: any) => {
                              if (response.status == 200) {
                                let newNote: DatumNote = {
                                  refNo: emailRecord.refNo,
                                  date: this.datePipe
                                    .transform(new Date(), 'yyyy-MM-dd')
                                    ?.toString()!,
                                  addedBy:
                                    this.msalService.instance.getActiveAccount()!
                                      .name!,
                                  initiatedBy: 'Mk3 Staff',
                                  noteTypeId: 4,
                                  subTypeId: 2,
                                  reasonId: 14,
                                  notes:
                                    instructionType + ' - ID ' + emailRecordId.toString()
                                    + ' Retracted to ' + contractorOrInternalTrade + ' ' +
                                    tradeName +
                                    ' (ID ' +
                                    tradeId +
                                    '). Reason: ' +
                                    retractReason,
                                  private: -1,
                                  timeStamp: null,
                                  followUpDate: null,
                                  followUpUser: null,
                                  followUpComplete: null,
                                  clientId: 1,
                                  addedById: 0,
                                  claimNoteInitiatedById: 1
                                };

                                //Intermittant failing
                                this.restService
                                  .addNewNoteToDatum(newNote)
                                  .pipe(first())
                                  .subscribe({
                                    next: () => {
                                      let jobHistory = new JobHistory();
                                      jobHistory.jobId = emailRecordId;
                                      jobHistory.statusId = (instructionType == "quote request") ? 28 : 2;
                                      jobHistory.comments = retractReason;
                                      jobHistory.date = null;//new Date();
                                      jobHistory.addedBy =
                                        this.msalService.instance.getActiveAccount()!.name!;
                                      jobHistory.timeStamp = null;
                                      this.restService
                                        .addNewJobHistoryRecord(jobHistory)
                                        .subscribe((x) => {
                                          console.log(x);
                                          Swal.fire(
                                            instructionType + ' Retracted successfully!\r\nEmail has been sent to the ' + contractorOrInternalTrade,
                                            '',
                                            'success'
                                          ).then(() => {
                                            if (emailRecordId) {
                                              this.router
                                                .navigate([
                                                  '../job-details/' +
                                                  emailRecordId,
                                                ])
                                                .then(() => {
                                                  window.location.reload();
                                                });
                                            }
                                          });
                                        });
                                    },
                                  });
                              } else {
                                Swal.fire(
                                  'Error Retracting the Instruction 0: Please report to IT with the details and a screenshot of your full page.' +
                                  'EmailRecordId = ' + emailRecordId + ', Sent By = ' + emailRecord.sentBy + ', Contractor/ InternalTrade = ' + contractorOrInternalTrade + ', Subject = ' + emailRecord.subject,
                                  '',
                                  'error'
                                );
                              }
                            },
                            (err: any) => {
                              try {
                                this.errorService.sendErrorDetails(
                                  err,
                                  'RetractEmailRecord 1',
                                  'utilsService.retractEmailRecord',
                                  'EmailRecordId = ' + emailRecordId + ', Sent By = ' + emailRecord.sentBy + ', Contractor/ InternalTrade = ' + contractorOrInternalTrade + ', Subject = ' + emailRecord.subject
                                );
                              } catch (error: any) {
                                Swal.fire(
                                  'Error Retracting the Instruction 1: Please report to IT with the details and a screenshot of your full page.' +
                                  'Error Message = ' + error.message + ', EmailRecordId = ' + emailRecordId + ', Sent By = ' + emailRecord.sentBy + ', Contractor/ InternalTrade = ' + contractorOrInternalTrade + ', Subject = ' + emailRecord.subject,
                                  '',
                                  'error'
                                );
                              }

                              Swal.fire(
                                'Error Retracting the Instruction 2: Please report to IT with the details and a screenshot of your full page.' +
                                'Error Message = ' + err + ', EmailRecordId = ' + emailRecordId + ', Sent By = ' + emailRecord.sentBy + ', Contractor/ InternalTrade = ' + contractorOrInternalTrade + ', Subject = ' + emailRecord.subject,
                                '',
                                'error'
                              );
                              try {
                                this.errorService.sendErrorDetails(
                                  err,
                                  'RetractEmailRecord 2',
                                  'utilsService.retractEmailRecord',
                                  'EmailRecordId = ' + emailRecordId + ', Sent By = ' + emailRecord.sentBy + ', Contractor/ InternalTrade = ' + contractorOrInternalTrade + ', Subject = ' + emailRecord.subject
                                );
                              }
                              catch (error: any) {
                                Swal.fire(
                                  'Error Retracting the Instruction 3: Please report to IT with the details and a screenshot of your full page.' +
                                  'Error Message = ' + error.message + ', EmailRecordId = ' + emailRecordId + ', Sent By = ' + emailRecord.sentBy + ', Contractor/ InternalTrade = ' + contractorOrInternalTrade + ', Subject = ' + emailRecord.subject,
                                  '',
                                  'error'
                                );
                              }
                            },
                          );
                      });
                  });
              } catch {
                Swal.fire(
                  'Error Retracting the Instruction 3: Please report to IT with the details and a screenshot of your full page.' +
                  'EmailRecordId = ' + emailRecordId + ', Sent By = ' + emailRecord.sentBy + ', Contractor/ InternalTrade = ' + contractorOrInternalTrade + ', Subject = ' + emailRecord.subject,
                  '',
                  'error'
                );
              }
            },
            /*             error: (error) => {
                          console.log(error);
                          this.alertService.error(error);
                        }, */
            error: (error) => {
              try {
                this.errorService.sendErrorDetails(
                  error,
                  'RetractEmailRecord 3',
                  'utilsService.retractEmailRecord',
                  'EmailRecordId = ' + emailRecordId + ', Sent By = ' + emailRecord.sentBy + ', Contractor/ InternalTrade = ' + contractorOrInternalTrade + ', Subject = ' + emailRecord.subject
                );
              } catch (error: any) {
                Swal.fire(
                  'Error Retracting the Instruction 4: Please report to IT with the details and a screenshot of your full page.' +
                  'Error Message = ' + error.message + ', EmailRecordId = ' + emailRecordId + ', Sent By = ' + emailRecord.sentBy + ', Contractor/ InternalTrade = ' + contractorOrInternalTrade + ', Subject = ' + emailRecord.subject,
                  '',
                  'error'
                );
              }

              Swal.fire(
                'Error Retracting the Instruction 5: Please report to IT with the details and a screenshot of your full page.' +
                'Error Message = ' + error + ', EmailRecordId = ' + emailRecordId + ', Sent By = ' + emailRecord.sentBy + ', Contractor/ InternalTrade = ' + contractorOrInternalTrade + ', Subject = ' + emailRecord.subject,
                '',
                'error'
              );
            },
          });
      }
    });
  }
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
